module.exports = __webpack_public_path__ + "img/logo_6.d91806fc.png";